import { Options } from "@contentful/rich-text-react-renderer"

/** Like variants, this merges rich text options so that you can override defaults for specific components */
const mergeOptions = (
  defaultOptions?: Options,
  overrideOptions?: Options
): Options => ({
  renderMark: {
    ...(defaultOptions && defaultOptions.renderMark),
    ...(overrideOptions && overrideOptions.renderMark),
  },
  renderNode: {
    ...(defaultOptions && defaultOptions.renderNode),
    ...(overrideOptions && overrideOptions.renderNode),
  },
})

export default mergeOptions
